import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "supervisor-page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Сравнение отчетов супервайзера", -1)
const _hoisted_3 = { class: "row mt-3" }

import { computed, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useProgramsStore } from '@/stores/programs';
import { useAccountStore } from '@/stores/account';
import SupervisingTable from '@/components/SupervisingTable.vue';
import TeamReportTable from '@/components/TeamReportTable.vue';
import TeamLimitsTable from '@/components/TeamLimitsTable.vue';
import FeedbackGrid from '@/components/FeedbackGrid.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SupervisorPage',
  setup(__props) {

const router = useRouter()
const programId = computed(() => {
  return router.currentRoute.value.params.programId as string
})
const programStore = useProgramsStore()
const program = computed(() => {
  if (programId.value) {
    return programStore.programs.find(item => item.id === programId.value)
  }
  return null
})

const accountStore = useAccountStore()
const teams = computed(() => {
  return program.value?.teams.filter(item => item.supervisorId === accountStore.currentUser?.id)
})


const currentTab = ref("supervising")

const currentTeamId = ref<string | null>(null)
watch(() => program.value, () => {
  if (!program.value) return
  const team = teams.value && teams.value[0]
  if (!team) return
  currentTeamId.value = team?.id
}, { immediate: true })

const currentTeam = computed(() => {
  return program.value?.teams.find(item => item.id === currentTeamId.value)
})

watch(() => currentTeam.value, () => {
  if (!currentTeam.value) return
  programStore.requestReports(currentTeam.value)
}, { immediate: true })


return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_v_tabs, {
        modelValue: currentTab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentTab).value = $event)),
        color: "primary"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tab, { value: "supervising" }, {
            default: _withCtx(() => [
              _createTextVNode("Супервизия")
            ]),
            _: 1
          }),
          _createVNode(_component_v_tab, { value: "reports" }, {
            default: _withCtx(() => [
              _createTextVNode("Отчеты трекера")
            ]),
            _: 1
          }),
          _createVNode(_component_v_tab, { value: "limits" }, {
            default: _withCtx(() => [
              _createTextVNode("Ограничения")
            ]),
            _: 1
          }),
          _createVNode(_component_v_tab, { value: "feedback" }, {
            default: _withCtx(() => [
              _createTextVNode("Обратная связь")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_select, {
        modelValue: currentTeamId.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentTeamId).value = $event)),
        items: _unref(teams) || [],
        class: "v-select-min",
        variant: "outlined",
        label: "Команда",
        "item-value": "id",
        "item-title": "name"
      }, null, 8, ["modelValue", "items"])
    ]),
    _createVNode(_component_v_window, {
      modelValue: currentTab.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currentTab).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_window_item, { value: "supervising" }, {
          default: _withCtx(() => [
            _createVNode(SupervisingTable, {
              "program-id": _unref(programId),
              "team-id": currentTeamId.value,
              "supervisor-id": _unref(accountStore).currentUser?.id
            }, null, 8, ["program-id", "team-id", "supervisor-id"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, { value: "reports" }, {
          default: _withCtx(() => [
            _createVNode(TeamReportTable, { team: _unref(currentTeam) }, null, 8, ["team"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, { value: "limits" }, {
          default: _withCtx(() => [
            _createVNode(TeamLimitsTable, {
              team: _unref(currentTeam),
              class: "mt-2"
            }, null, 8, ["team"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, { value: "feedback" }, {
          default: _withCtx(() => [
            _createVNode(FeedbackGrid, {
              "tracker-id": _unref(currentTeam)?.trackerId,
              "program-id": _unref(programId)
            }, null, 8, ["tracker-id", "program-id"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})